'use client';

import React from 'react';
import { Link } from 'react-router-dom';
import FadeIn from '../components/FadeIn';

export default function ShootYourShotPage() {
  return (
    <FadeIn>
      <div style={{ fontFamily: "Helvetica, Arial, sans-serif" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@300;400;500;600&display=swap');
        @keyframes sunrise {
          0% {
            opacity: 0;
            transform: translateX(-50%) translateY(40px) scaleY(0.5);
          }
          60% {
            opacity: 1;
            transform: translateX(-50%) translateY(0px) scaleY(1);
          }
          100% {
            opacity: 1;
            transform: translateX(-50%) translateY(0px) scaleY(1);
          }
        }
        @keyframes grain {
          0%, 100% { transform: translate(0, 0); }
          10% { transform: translate(-5%, -10%); }
          20% { transform: translate(-15%, 5%); }
          30% { transform: translate(7%, -25%); }
          40% { transform: translate(-5%, 25%); }
          50% { transform: translate(-15%, 10%); }
          60% { transform: translate(15%, 0%); }
          70% { transform: translate(0%, 15%); }
          80% { transform: translate(3%, 35%); }
          90% { transform: translate(-10%, 10%); }
        }
      `}</style>

      {/* Hero */}
      <div style={{
        backgroundColor: '#000000',
        padding: '180px 32px 120px',
        textAlign: 'center',
        position: 'relative',
        overflow: 'hidden',
        minHeight: '80vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
        {/* Warm glow from bottom — sunrise animation */}
        <div style={{
          position: 'absolute',
          bottom: 0,
          left: '50%',
          transform: 'translateX(-50%)',
          width: '120%',
          height: '400px',
          background: 'radial-gradient(ellipse at bottom center, rgba(180, 120, 60, 0.18) 0%, rgba(120, 60, 30, 0.07) 40%, transparent 70%)',
          pointerEvents: 'none',
          opacity: 0,
          animation: 'sunrise 3s ease-out 0.3s forwards',
        }} />

        <div style={{ position: 'relative', maxWidth: '700px', margin: '0 auto' }}>
          <h1 style={{
            fontFamily: "'Cormorant Garamond', Garamond, Georgia, serif",
            fontSize: '6rem',
            fontWeight: 500,
            color: '#ffffff',
            margin: '0 0 48px',
            letterSpacing: '-0.03em',
            lineHeight: 1.1,
            transform: 'scaleX(0.75)',
          }}>
            Shoot your shots.
          </h1>

          <p style={{
            fontSize: '1rem',
            color: '#999999',
            margin: '0 auto',
            lineHeight: 1.6,
            fontWeight: 500,
            maxWidth: '500px',
          }}>
            Over 270 projects have started pre-production since January 2026. Features. Shorts. Student films. Passion projects. First films.
          </p>
        </div>
      </div>

      {/* The work */}
      <div style={{
        backgroundColor: '#000000',
        padding: '120px 32px',
        borderTop: '1px solid #111111',
        position: 'relative',
        overflow: 'hidden',
      }}>
        {/* Film grain texture */}
        <svg style={{ position: 'absolute', width: 0, height: 0 }}>
          <filter id="grain-filter">
            <feTurbulence type="fractalNoise" baseFrequency="0.65" numOctaves="3" stitchTiles="stitch" />
            <feColorMatrix type="saturate" values="0" />
          </filter>
        </svg>
        <div style={{
          position: 'absolute',
          inset: '-50%',
          filter: 'url(#grain-filter)',
          pointerEvents: 'none',
          animation: 'grain 8s steps(10) infinite',
          opacity: 0.08,
        }} />
        <div style={{ maxWidth: '600px', margin: '0 auto', position: 'relative' }}>
          <p style={{
            fontSize: '1rem',
            color: '#888888',
            lineHeight: 1.6,
            margin: '0 0 32px',
            textAlign: 'center',
          }}>
            Locations fall through. Schedules conflict. Vendors cancel. The budget gets tighter. The sun sets before you get the shot.
          </p>
          <p style={{
            fontSize: '1rem',
            color: '#888888',
            lineHeight: 1.6,
            margin: 0,
            textAlign: 'center',
          }}>
            You shoot anyway. That's filmmaking.
          </p>
        </div>
      </div>

      {/* Stats — understated */}
      <div style={{
        backgroundColor: '#000000',
        padding: '100px 32px',
        borderTop: '1px solid #111111',
        position: 'relative',
        overflow: 'hidden',
      }}>
        {/* Lens rings */}
        {Array.from({ length: 20 }, (_, i) => {
          const size = 60 + i * 80;
          const opacity = 0.1 - (i * 0.004);
          return (
            <div key={i} style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: `${size}px`,
              height: `${size}px`,
              borderRadius: '50%',
              border: `1px solid rgba(255, 255, 255, ${Math.max(opacity, 0.02)})`,
              pointerEvents: 'none',
            }} />
          );
        })}
        <div style={{
          maxWidth: '800px',
          margin: '0 auto',
          position: 'relative',
          display: 'flex',
          justifyContent: 'center',
          gap: '80px',
          flexWrap: 'wrap',
        }}>
          <div style={{ textAlign: 'center' }}>
            <p style={{
              fontFamily: "'Cormorant Garamond', Garamond, Georgia, serif",
              fontSize: '3rem',
              fontWeight: 500,
              color: '#ffffff',
              margin: '0 0 8px',
              letterSpacing: '-0.02em',
              transform: 'scaleX(0.8)',
            }}>
              270+
            </p>
            <p style={{
              fontSize: '0.8rem',
              color: '#555555',
              margin: 0,
              fontWeight: 500,
              textTransform: 'uppercase',
              letterSpacing: '0.08em',
            }}>
              Productions launched
            </p>
          </div>
        </div>
        <p style={{
          fontSize: '0.7rem',
          color: '#333333',
          margin: '32px auto 0',
          textAlign: 'center',
        }}>
          Stats from March 2026
        </p>
      </div>

      {/* Share */}
      <div style={{
        backgroundColor: '#000000',
        padding: '100px 32px',
        borderTop: '1px solid #111111',
        textAlign: 'center',
        position: 'relative',
        overflow: 'hidden',
      }}>
        {/* Bokeh dots — out-of-focus set lights */}
        {[
          { size: 80, x: '10%', y: '20%', opacity: 0.08 },
          { size: 120, x: '85%', y: '30%', opacity: 0.06 },
          { size: 60, x: '75%', y: '75%', opacity: 0.09 },
          { size: 100, x: '20%', y: '70%', opacity: 0.06 },
          { size: 40, x: '50%', y: '15%', opacity: 0.08 },
          { size: 90, x: '40%', y: '85%', opacity: 0.05 },
        ].map((dot, i) => (
          <div key={i} style={{
            position: 'absolute',
            left: dot.x,
            top: dot.y,
            width: `${dot.size}px`,
            height: `${dot.size}px`,
            borderRadius: '50%',
            background: `radial-gradient(circle, rgba(200, 160, 100, ${dot.opacity * 3}) 0%, rgba(200, 160, 100, ${dot.opacity}) 40%, transparent 70%)`,
            pointerEvents: 'none',
            transform: 'translate(-50%, -50%)',
          }} />
        ))}
        <div style={{ maxWidth: '500px', margin: '0 auto', position: 'relative' }}>
          <p style={{
            fontSize: '1.3rem',
            color: '#ffffff',
            margin: '0 0 12px',
            fontWeight: 500,
            lineHeight: 1.5,
          }}>
            Share what you're making.
          </p>
          <p style={{
            fontSize: '0.95rem',
            color: '#666666',
            margin: '0 0 32px',
            lineHeight: 1.6,
          }}>
            On-set photos, wrap day pics, behind the scenes.
          </p>
          <a
            href="mailto:support@davinese.com"
            style={{
              display: 'inline-block',
              padding: '12px 32px',
              border: '1px solid #333333',
              borderRadius: '100px',
              color: '#ffffff',
              fontSize: '0.85rem',
              fontWeight: 600,
              textDecoration: 'none',
              transition: 'border-color 0.2s ease',
            }}
            onMouseEnter={(e) => { e.currentTarget.style.borderColor = '#666666'; }}
            onMouseLeave={(e) => { e.currentTarget.style.borderColor = '#333333'; }}
          >
            Send us a photo
          </a>
        </div>
      </div>

      {/* Closing */}
      <div style={{
        backgroundColor: '#000000',
        padding: '150px 32px',
        textAlign: 'center',
        borderTop: '1px solid #111111',
        position: 'relative',
        overflow: 'hidden',
      }}>
        {/* Vignette */}
        <div style={{
          position: 'absolute',
          inset: 0,
          background: 'radial-gradient(ellipse at center, transparent 40%, rgba(0, 0, 0, 0.6) 100%)',
          pointerEvents: 'none',
        }} />
        {/* Warm center glow */}
        <div style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '600px',
          height: '400px',
          background: 'radial-gradient(ellipse, rgba(180, 130, 70, 0.06) 0%, transparent 70%)',
          pointerEvents: 'none',
        }} />

        <div style={{ position: 'relative', maxWidth: '500px', margin: '0 auto' }}>
          <p style={{
            fontSize: '1.3rem',
            color: '#ffffff',
            margin: '0 0 32px',
            lineHeight: 1.6,
            fontWeight: 500,
          }}>
            Your film is waiting. The tools are ready.
          </p>
          <Link
            to="/production"
            style={{
              display: 'inline-block',
              padding: '14px 36px',
              backgroundColor: '#ffffff',
              color: '#000000',
              borderRadius: '100px',
              fontSize: '0.9rem',
              fontWeight: 600,
              textDecoration: 'none',
              transition: 'opacity 0.2s ease',
            }}
            onMouseEnter={(e) => { e.currentTarget.style.opacity = '0.85'; }}
            onMouseLeave={(e) => { e.currentTarget.style.opacity = '1'; }}
          >
            Learn more
          </Link>
        </div>
      </div>
      </div>
    </FadeIn>
  );
}
